import React, { lazy, Suspense } from "react";
import { Switch, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { AGENCY_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { PrivateRoute } from "shared/PrivateRoute";

export const AgencyViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <PrivateRoute
          section={"agency"}
          path={`${AGENCY_PREFIX_PATH}/clone`}
          component={lazy(() => import(`./CloningPage`))}
          exact
        />
        <PrivateRoute
          section={"agency"}
          path={`${AGENCY_PREFIX_PATH}/phone-number`}
          component={lazy(() => import(`./TwilioPhoneNumbers`))}
          exact
        />
        <PrivateRoute
          section={"agency"}
          path={`${AGENCY_PREFIX_PATH}/charting`}
          component={lazy(() => import(`./ChartingPage`))}
          exact
        />
        <PrivateRoute
          section={"agency"}
          path={`${AGENCY_PREFIX_PATH}/charting/categories`}
          component={lazy(() => import(`./ChartingPage/ChartingCategories`))}
          exact
        />
        <PrivateRoute
          section={"agency"}
          path={`${AGENCY_PREFIX_PATH}/charting/builder/:id?`}
          component={lazy(() => import(`./ChartingPage/ChartingBuilder`))}
          exact
        />
        <PrivateRoute
          section={"agency"}
          path={`${AGENCY_PREFIX_PATH}/questionnaires`}
          component={lazy(() => import(`./QuestionnairesPage`))}
          exact
        />
        <PrivateRoute
          section={"agency"}
          path={`${AGENCY_PREFIX_PATH}/questionnaires/categories`}
          component={lazy(() =>
            import(`./QuestionnairesPage/QuestionnaireCategories`)
          )}
          exact
        />
        <PrivateRoute
          section={"agency"}
          path={`${AGENCY_PREFIX_PATH}/questionnaires/builder/:id?`}
          component={lazy(() =>
            import(`./QuestionnairesPage/QuestionnaireBuilder`)
          )}
          exact
        />
        <Redirect
          from={`${AGENCY_PREFIX_PATH}`}
          to={`${AUTH_PREFIX_PATH}/login`}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AgencyViews);
